export default __webpack_public_path__ + "static/media/foto4.bf931dc1.jpg";